import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { cardHover, clearFix } from '../../styles/theme';
import { linkType, responsiveImageType } from '../../propTypes';
import DeferredCard from '../DeferredCard';
import Caption, { captionDefaultProps, captionPropTypes } from './Caption';

export const aspect = 4 / 3;
const Article = ({
  category, classes, className, image, link, readTime, publishedDate, slug, title,
}) => {
  const ready = !!slug;
  return (
    <DeferredCard
      aspect={aspect}
      className={cn(className, classes.article)}
      image={image}
      imageClassName={classes.image}
      link={link}
      ready={ready}
      title={title}
    >
      <Caption
        className={classes.caption}
        category={category}
        readTime={readTime}
        publishedDate={publishedDate}
        slug={slug}
        title={title}
      />
    </DeferredCard>
  );
};

export const articlePropTypes = {
  ...captionPropTypes,
  image: responsiveImageType,
  link: linkType,
};

Article.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  ...articlePropTypes,
};

export const articleDefaultProps = {
  ...captionDefaultProps,
  image: undefined,
  link: undefined,
};

Article.defaultProps = {
  className: undefined,
  ...articleDefaultProps,
};

export default injectSheet({
  article: {
    position: 'relative',
    ...clearFix,
    ...cardHover('$image'),
  },
  image: {
    position: 'absolute',
    left: 0,
    top: 0,
  },
  caption: {
    position: 'relative',
    marginLeft: 10,
    marginRight: 10,
    boxShadow: `0 2px 9px 0 ${theme.colors.blackOpacity10}`,
    marginTop: '59%',
    '-webkit-transform': 'translate3d(0,0,0)',
    [theme.breakpoints.up('md')]: {
      marginRight: '16%',
    },
  },
})(Article);
